var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "#E8FDF1",
    stroke: "#26A65B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 21C42 24.0042 41.3554 26.9734 40.1098 29.7072C38.8642 32.441 37.0465 34.8757 34.7795 36.8469C32.5125 38.8182 29.8489 40.2801 26.9686 41.1339C24.0883 41.9878 21.0584 42.2137 18.0833 41.7965C15.1082 41.3792 12.2573 40.3285 9.72304 38.7152C7.18875 37.102 5.0301 34.9638 3.39282 32.445C1.75554 29.9261 0.677755 27.0854 0.232222 24.1144C-0.213311 21.1434 -0.0162165 18.1114 0.810199 15.2232L10.4802 17.99C10.0496 19.4949 9.9469 21.0747 10.179 22.6227C10.4112 24.1707 10.9728 25.6509 11.8259 26.9634C12.679 28.2758 13.8037 29.3899 15.1242 30.2305C16.4447 31.071 17.9301 31.6185 19.4803 31.8359C21.0304 32.0533 22.6092 31.9356 24.1099 31.4907C25.6107 31.0458 26.9985 30.2841 28.1798 29.257C29.361 28.2299 30.3081 26.9613 30.9571 25.5368C31.6061 24.1124 31.942 22.5653 31.942 21H42Z",
    fill: "#26A65B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0742 19.1641V17.8379C18.6895 17.8105 19.1201 17.7695 19.3662 17.7148C19.7581 17.6283 20.0771 17.4551 20.3232 17.1953C20.4919 17.0176 20.6195 16.7806 20.7061 16.4844C20.7562 16.3066 20.7812 16.1745 20.7812 16.0879H22.4014V26H20.4053V19.1641H18.0742Z",
    fill: "#26A65B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.bea71fc611ea07b22a8ce36906beb38f.svg";
export { ForwardRef as ReactComponent };